export default "__VITE_ASSET__2N0EQ6zP__"